import { Navigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import Require from "./auth/Require";
import Chat from "../pages/Chat";
import { TEAM_MOBILE_MEDIA_QUERY } from "../pages/Team/utils/teamUiUtils";
import { WORKSPACE_NAV_SEARCH } from "../utils/teamNavigation";

/**
 * Home (`/`): no mobile abre o atendimento com a barra da Equipe;
 * no desktop mantém o chat padrão (sem workspaceNav).
 */
export default function HomeIndex() {
  const isMobile = useMediaQuery(TEAM_MOBILE_MEDIA_QUERY);
  const location = useLocation();

  if (isMobile) {
    const params = new URLSearchParams(location.search);
    params.set(WORKSPACE_NAV_SEARCH, "1");
    const query = params.toString();
    return <Navigate to={query ? `/chat?${query}` : `/chat?${WORKSPACE_NAV_SEARCH}=1`} replace />;
  }

  return (
    <Require resource="chat" action="view">
      <Chat />
    </Require>
  );
}
